/**
 * Shared cell style constants for order list table columns.
 * Used by all 6 tab files (AllOrders, DeliveredOrders, RTOOrders, etc.)
 */
import { FONT, SIZE, WEIGHT } from '../../../styles/foundation/typography';
import { NAVY, SUBTLE, SUCCESS, ERROR, INFO, WARNING, ORANGE, PURPLE } from '../../../styles/foundation/colors';

// ── Text styles ────────────────────────────────────────────────
export const primaryTextSx = {
  fontFamily: FONT,
  fontWeight: WEIGHT.semibold,
  fontSize: SIZE['2xs'],
  color: NAVY,
  lineHeight: 1.4,
};

export const secondaryTextSx = {
  fontFamily: FONT,
  fontWeight: WEIGHT.regular,
  fontSize: SIZE['2xs'],
  color: NAVY,
  lineHeight: 1.4,
};

export const tertiaryTextSx = {
  fontFamily: FONT,
  fontWeight: WEIGHT.regular,
  fontSize: 11,
  color: SUBTLE,
  lineHeight: 1.3,
};

export const awbTextSx = {
  fontFamily: FONT,
  fontWeight: WEIGHT.semibold,
  fontSize: SIZE['2xs'],
  color: NAVY,
  lineHeight: 1.4,
};

// ── Cell container ─────────────────────────────────────────────
export const cellStackSx = {
  display: 'flex',
  flexDirection: 'column',
  gap: 0.3,
  py: 1,
};

// ── Status chip ────────────────────────────────────────────────
const STATUS_COLORS = {
  DELIVERED: SUCCESS,
  RTO_DELIVERED: ERROR,
  RTO_REQUESTED: ERROR,
  RTO: ERROR,
  RTO_INTRANSIT: ORANGE,
  RTO_CONTACT_CUSTOMER_CARE: ORANGE,
  RTO_SHIPMENT_DELAY: ORANGE,
  RTO_OUT_FOR_DELIVERY: ORANGE,
  RTO_FAILED: ERROR,
  FAILED_DELIVERY: ERROR,
  INTRANSIT: INFO,
  REACHED_AT_DESTINATION: INFO,
  SHIPPED: INFO,
  MISSING: WARNING,
  SHIPMENT_DELAYED: WARNING,
  CONTACT_CUSTOMER_CARE: WARNING,
  SHIPMENT_HELD: WARNING,
  PICKED_UP: INFO,
  OUT_FOR_DELIVERY: INFO,
  ORDER_PLACED: INFO,
  PICKUP_PENDING: WARNING,
  OUT_FOR_PICKUP: INFO,
  PICKUP_FAILED: ERROR,
  MANIFESTED: INFO,
  AWB_REGISTERED: INFO,
  CANCELLED_ORDER: SUBTLE,
  CANCELLED_PENDING: SUBTLE,
};

export const getStatusChipSx = (status) => {
  const color = STATUS_COLORS[status] || SUBTLE;
  const textColor = color === WARNING ? '#F57F17' : color;
  return {
    fontFamily: FONT,
    fontWeight: WEIGHT.semibold,
    fontSize: 11,
    height: 24,
    // never bleed across column boundaries — ellipsize inside the cell instead
    maxWidth: '100%',
    bgcolor: color + '18',
    color: textColor,
    border: `1px solid ${color}40`,
    '& .MuiChip-label': { px: 1 },
  };
};

// ── Payment chip ───────────────────────────────────────────────
export const getPaymentChipSx = (mode) => {
  const color = mode === 'COD' ? ERROR : SUCCESS;
  return {
    fontFamily: FONT,
    fontWeight: WEIGHT.semibold,
    fontSize: 11,
    height: 22,
    bgcolor: color + '14',
    color,
    border: `1px solid ${color}30`,
    '& .MuiChip-label': { px: 0.8 },
  };
};
